// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"a711d502","400":"94430996","650":"e6583520","731":"9f5d026f","928":"a0e269f1","955":"983f7615"}[chunkId] + ".chunk.css";
};